import { cB as i, cE as o, c as n } from "./ghl-ui.es361.js";
const e = i("empty", `
 display: flex;
 flex-direction: column;
 align-items: center;
 font-size: var(--n-font-size);
`, [o("icon", `
 width: var(--n-icon-size);
 height: var(--n-icon-size);
 font-size: var(--n-icon-size);
 line-height: var(--n-icon-size);
 color: var(--n-icon-color);
 transition:
 color .3s var(--n-bezier);
 `, [n("+", [o("description", `
 margin-top: 8px;
 `)])]), o("description", `
 transition: color .3s var(--n-bezier);
 color: var(--n-text-color);
 `), o("extra", `
 text-align: center;
 transition: color .3s var(--n-bezier);
 margin-top: 12px;
 color: var(--n-extra-text-color);
 `)]);
export {
  e as default
};
